/* eslint-disable no-unused-vars */
import React from "react";
import { useTranslation } from "react-i18next";
import Utilities from "../../lib/Utilities";

const util = new Utilities();

export default function StoreSummaryData(props) {
  const { selectedStore, closeSummaryStoreData, openImageSlide, copyUrl } =
    props;
  const { t } = useTranslation();

  const rating = Math.floor(selectedStore.srRating);
  const images = selectedStore.sdPhoto ? selectedStore.sdPhoto.split("|") : [];

  return (
    <>
      <div className="px-3 d-flex flex-column justify-content-between h-100">
        <div>
          <h6
            className="cursor_pointer cursor_pointer_fw_bold py-2"
            onClick={() => {
              closeSummaryStoreData();
            }}
          >
            ← {t("storeMall.storeDetail.goBack")}
          </h6>

          <div className="w-100 rounded overflow-hidden mb-3 position-relative">
            {images.length > 0 && (
              <div
                className="position-absolute px-2 rounded-lg text-white font-size-09"
                style={{ right: 8, top: 8, background: "rgba(0,0,0,0.7)" }}
              >
                1/{images.length}
              </div>
            )}
            {images[0] && (
              <div
                className="cursor_pointer cursor-child-zoom w-100"
                style={{ height: 200 }}
              >
                <img
                  className="zoom-child w-100"
                  src={images[0]}
                  alt={images[0]}
                  style={{ height: 200 }}
                  onClick={() => {
                    openImageSlide(0);
                  }}
                />
              </div>
            )}
            {!images[0] && (
              <div
                className="w-100 bg-freiscop-05 text-secondary d-flex flex-column justify-content-center align-items-center"
                style={{
                  height: 200,
                }}
              >
                <span className="h1 mb-0 ">
                  <i className="fa-solid fa-warehouse" />
                </span>
                <p className="text-secondary font-weight-bold">
                  {t("storeMall.storeDetail.readyImage")}
                </p>
              </div>
            )}
          </div>

          <div className="d-flex flex-row justify-content-between align-items-center">
            <p className="h6 mb-0 flex-fill text-truncate font-weight-bold text-freiscop">
              {selectedStore.smName}
            </p>
            <i
              className="fa-solid fa-share-from-square cursor_pointer text-secondary ml-3"
              onClick={() => {
                copyUrl();
              }}
            />
          </div>
          {rating > 0 && (
            <div className="font-weight-bold mb-1">
              {t("storeMall.review")} <i className="icon-star text-warning" />{" "}
              {rating} /({selectedStore.srCount}
              {t("storeMall.count")})
            </div>
          )}
          <p className="p-0 m-0 mt-1">{selectedStore.smCustoms}</p>
          <p className="p-0 m-0">
            {util.telFormatConvert(selectedStore.smTel)}
          </p>
          <p className="p-0 m-0">{selectedStore.smAddrFull}</p>
          <div className="border border-bottom-0 my-3" />
        </div>
      </div>
    </>
  );
}
